__turbopack_context__.v({
  "chevron": "b88EBG_chevron",
  "dropdownPill": "b88EBG_dropdownPill",
  "input": "b88EBG_input",
  "inputField": "b88EBG_inputField",
  "label": "b88EBG_label",
  "pill-group": "b88EBG_pill-group",
  "pills-wrapper": "b88EBG_pills-wrapper",
  "popoverDropdown": "b88EBG_popoverDropdown",
  "remove": "b88EBG_remove",
  "root": "b88EBG_root",
  "section": "b88EBG_section",
  "target": "b88EBG_target",
  "wrapper": "b88EBG_wrapper",
});
